import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-what-we-do',
  templateUrl: './what-we-do.component.html',
  styleUrls: ['./what-we-do.component.less']
})
export class WhatWeDoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
